import { defineStore } from 'pinia';
import { useCustomerStore } from './customer';
import type { ProductsMenu } from '@/types/products';

export const useAssortmentStore = defineStore('assortment', () => {
  const assortmentId = ref<string | null>(null);
  const assortmentMenu = ref<ProductsMenu[] | null>(null);

  const fetchAssortmentMenu = async (): Promise<void> => {
    if (!assortmentId.value) {
      assortmentMenu.value = null;
      return;
    }
    const { $productService } = useNuxtApp();
    const { data, error } = await $productService.fetchMenu(assortmentId.value);
    const result = error ? [] : data;
    assortmentMenu.value = Object.freeze(result) as ProductsMenu[];
  };

  const fetchAssortmentId = async (): Promise<void> => {
    const {
      public: { assortmentService },
    } = useRuntimeConfig();
    const { $assortmentService } = useNuxtApp();

    if (!assortmentService.startsWith('http')) {
      return;
    }
    const { currentCustomerId } = useCustomerStore();
    const { data, error } = await $assortmentService.fetchAssortment(currentCustomerId);
    if (!data || error || data.name === 'default') {
      clearAssortment();
      return;
    }
    if (data.name === assortmentId.value) {
      return;
    }
    assortmentId.value = data.name;
    fetchAssortmentMenu();
  };

  const clearAssortment = (): void => {
    assortmentId.value = null;
    assortmentMenu.value = null;
  };

  return {
    assortmentId,
    assortmentMenu,
    fetchAssortmentMenu,
    fetchAssortmentId,
    clearAssortment,
  };
});
